$(document).ready(() =>
  $('[data-toggle="tooltip"]').tooltip({
    container: 'body',
    html: true
  })
);



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/tooltip.js